import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserModel, ShoppingCartModel } from '../../core/models/ShoppingCart.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ReconcileItemListDialogComponent } from '../reconcile-item-list-dialog/reconcile-item-list-dialog.component';
import { ShoppingService } from '../../core/services/shopping.service';
import { HelperService } from '../../core/services/helper.service';
import { appApiResources, appVariables, appMessages } from '../../core/constants/Common.constant';
import { PromptComponent } from '../../layout/prompt/prompt.component';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { InstructorNotConfirmedComponent } from '../modals/instructor-not-confirmed/instructor-not-confirmed.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { InstructorResendConfirmationComponent } from '../modals/instructor-resend-confirmation/instructor-resend-confirmation.component';
declare let $: any;
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    forgotpasswordForm: FormGroup;
    UserModel: UserModel;
    fromLocal: UserModel;
    errorMessage: string;
    invalidEmailMessage: string;
    forgotErrorMessage: string;
    forgotMessage: string;
    forgotMessage2: string;
    ShoppingCart = new ShoppingCartModel();
    isUserRegister = true;
    isInstructorConfirmed = true;
    isvalidateInstructorConfimation = true;
    invalidInstructorConfimationMsg: string;

    constructor(private shoppingService: ShoppingService, public dialog: MatDialog, private router: Router,
        private helperservice: HelperService, private modalService: NgbModal) { }

    ngOnInit() {
        this.UserModel = new UserModel();
        this.initForm();
        this.shoppingService.LogInHeader.subscribe(isValid => {
            this.OnSubmitLogin();
        });

    }

    private initForm() {
        //    this.OnOpenReconcileDialog();
        this.shoppingService.IsEmptyShoppingCart.subscribe(isOpen => {
            if (this.router.url === '/ShoppingCart/checkout' && isOpen && !this.shoppingService.IsPromptShown) {
                this.shoppingService.IsPromptShown = true;
                this.ShowPrompt();
            }
        });
        this.loginForm = new FormGroup({
            // 'UserName': new FormControl(this.UserModel.UserName, [Validators.required, Validators.pattern(appVariables.RegexUserName)]),
            'UserName': new FormControl(this.UserModel.UserName, [Validators.required]),
            'Password': new FormControl(this.UserModel.Password,
                Validators.required)
        });
        this.forgotpasswordForm = new FormGroup({
            'UserName': new FormControl(this.UserModel.UserName,
                Validators.pattern(appVariables.RegexUserName)),
        });
    }

    OnSubmitLogin() {
        if (this.loginForm.status !== "INVALID" && this.isvalidateInstructorConfimation) {
            
            this.OnValidateEmail();
            this.OnLogIn();
        }
        else {
            this.invalidInstructorConfimationMsg = appMessages.invalidInstructorConfimationMsg;
            //this.router.navigate(['/ShoppingCart/checkout']);
        }

    }

    OnLogIn() {
        this.shoppingService.logIn(this.loginForm.value)
            .subscribe(
                (response) => {
                    this.helperservice.setUserToLocalStorage(response.Data);
                    this.fromLocal = this.helperservice.getUserFromLocalStorage();
                    this.shoppingService.setToken(this.fromLocal['token']);
                    if (this.fromLocal['status'] === 'Invalid username/password') {
                        this.errorMessage = appMessages.incorrectPassword;
                    } else {
                        let CookieVar = '';
                        // tslint:disable-next-line:max-line-length
                        let expiryDate = new Date();
                        expiryDate.setMonth(expiryDate.getMonth() + 1);
                        document.cookie = environment.CookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=.fadavis.com; path=/;';
                        // tslint:disable-next-line:max-line-length
                        CookieVar += response.Data.Email ? (!CookieVar ? 'UserName=' + response.Data.Email : '&UserName=' + response.Data.Email) : '';
                        CookieVar += '&AccessToken=' + '';
                        CookieVar += '&RefreshToken=' + '';
                        // tslint:disable-next-line:max-line-length
                        CookieVar += response.Data.token ? (!CookieVar ? 'TokenId=' + response.Data.token : '&TokenId=' + response.Data.token) : '';
                        // tslint:disable-next-line:max-line-length
                        CookieVar += response.Data.AccountID ? (!CookieVar ? 'AccountId=' + response.Data.AccountID : '&AccountId=' + response.Data.AccountID) : '';
                        CookieVar += '&AccountTypeId=' + (response.Data.Role == 'Student') ? '&AccountTypeId=' + 4 : (response.Data.Role == 'Instructor') ? '&AccountTypeId=' + 6 : '&AccountTypeId=' + '';//'';
                        CookieVar += '&LastUpdated=' + new Date();
                        //CookieVar += '&AccountTypeName=' + (response.Data.Role == 'Student') ? '&AccountTypeName=' + 4 : (response.Data.Role == 'Instructor') ? '&AccountTypeName=' + 6 : '&AccountTypeName=' + '';//response.Data.Role=='Student'?4:'Instructor'?6:''
                        //CookieVar+= response.Data.Role == 'Student' ? '&AccountTypeName=' + 4 : '&AccountTypeName=' + 6
                        // tslint:disable-next-line:max-line-length
                         
                        /*Comment By: shorya saxena
                          DESC: FullName key is added in cookie so that we can see user full name in the header 
                                when the user redirect to Fadavis application for more details refer  FAD-844 */
                        CookieVar += `&FullName=${response.Data.FirstName} ${response.Data.LastName}`;
                        document.cookie = environment.CookieName + '=' + CookieVar + ';expiryDate' + expiryDate + ';domain=.fadavis.com; path=/';
                        document.getElementsByTagName('body')[0].appendChild(this.shoppingService.LoadScript(response));
                        this.shoppingService.setUserDetails(this.fromLocal);
                        this.shoppingService.setDisplaySection('Login');
                        this.shoppingService.GetAddress();

                        this.shoppingService.IsLoggedIn.emit(true);
                        this.shoppingService.SetTimerCall.emit(true);

                        this.shoppingService.GetCartItemsFromAPI('', '')
                            .subscribe(
                                (response1) => {
                                    if (response1.Data.length > 0 && this.helperservice.getFromLocalStorage(appVariables.cartGUID)) {
                                        this.shoppingService.setPreviousCartItems(response1.Data);
                                        this.OnOpenReconcileDialog();
                                    } else {
                                        this.ShoppingCart.ProductIDs = '';
                                        this.ShoppingCart.ShoppingCartGUID = this.helperservice.getFromLocalStorage(appVariables.cartGUID);
                                        if (this.helperservice.getFromLocalStorage(appVariables.cartGUID) !== '') {
                                            this.shoppingService.ReconcileShoppingCartItems(this.ShoppingCart).subscribe(
                                                (response2: Response) => {
                                                    this.helperservice.setToLocalStorage(appVariables.cartGUID, '');
                                                    this.shoppingService.loadItems();
                                                },
                                                (error) => { }
                                            );
                                        } else {
                                            this.shoppingService.loadItems();
                                            this.shoppingService.GetApplicationDetails();
                                        }
                                    }
                                },
                                (error) => { }
                            );
                    }
                },
                (error) => {

                }
            );
    }



    ShowPrompt() {
        this.dialog.open(PromptComponent, {
            disableClose: true,
            hasBackdrop: true, // or false, depending on what you want
        });
    }
    OnOpenReconcileDialog() {
        this.dialog.open(ReconcileItemListDialogComponent, {
            disableClose: true,
            hasBackdrop: true, // or false, depending on what you want
            // height: '80%',
            // width: '80%',
            panelClass: 'cls-Reconcile-height',
        });
    }

    OnOpenForgotPassword() {
        this.OnResetForgotPassword();
        this.forgotpasswordForm.controls['UserName'].setErrors({ 'incorrect': true });
        $('#forgotPasswordModal').modal('toggle');
    }

    OnResetForgotPassword() {
        this.forgotpasswordForm.controls['UserName'].setValue('');
        this.forgotErrorMessage = '';
        this.forgotMessage = '';
        this.forgotMessage2 = '';
    }

    OnCloseforgotPassword(value: string) {
        $('#forgotPasswordModal').modal('toggle');
    }

    OnForgotPassword() {
        this.shoppingService.forgotPassword(this.forgotpasswordForm.value).subscribe(
            (response) => {
                if (response.Message === 'The Email ID does not exist') {
                    this.forgotMessage = appMessages.forgotIncorrectEmail1;
                    this.forgotMessage2 = appMessages.forgotIncorrectEmail2;
                } else {
                    // tslint:disable-next-line:max-line-length
                    this.forgotMessage = appMessages.forgotSuccess1.replace('#username', this.forgotpasswordForm.controls['UserName'].value);
                    this.forgotMessage2 = appMessages.forgotSuccess2;
                }
            },
            (error) => {
                if (JSON.parse(error._body).Message === 'The Email ID does not exist') {
                    this.forgotMessage = appMessages.forgotIncorrectEmail1;
                    this.forgotMessage2 = appMessages.forgotIncorrectEmail2;
                }
            }
        );
    }
    OnValidateEmail() {
        this.isvalidateInstructorConfimation = true;
        this.invalidInstructorConfimationMsg = ``;
        this.errorMessage = ``;
        const email = this.loginForm.controls['UserName'].value;
        if (email) {
            if(this.helperservice.IsEmailPatternValid(email)) {
            this.shoppingService.validateInstructorConfimation(email)
                .subscribe(
                    (response) => {
                        this.isUserRegister = response.Data[0];
                        this.isInstructorConfirmed = response.Data[1];
                        if (this.isUserRegister && !this.isInstructorConfirmed) {
                            
                            this.isvalidateInstructorConfimation = false;
                            
                            const modalRef = this.modalService.open(InstructorNotConfirmedComponent, { backdrop: true });
                            
                            modalRef.result.then((data) => {
                                if (data === 'resendConfirmation') {
                                    const resendModalRef = this.modalService.open(InstructorResendConfirmationComponent, { backdrop: true });
                                    resendModalRef.componentInstance.emailId = this.loginForm.controls['UserName'].value;
                                }
                            });
                        }
                        
                        
                        if (!this.isUserRegister) {
                            this.invalidEmailMessage = appMessages.invalidEmail;
                        }
                    },
                    (error) => { }
                );
        }
        else {
            this.isUserRegister = false;
            this.invalidEmailMessage = appMessages.invalidEmail;
        }
    }
    else {
        this.invalidEmailMessage = appMessages.invalidEmail;
    }
    }

}



// WEBPACK FOOTER //
// ./src/app/shoppingcart/login/login.component.ts